import { render } from "./PayPalConfirmModal.vue?vue&type=template&id=23a1a05c&scoped=true"
import script from "./PayPalConfirmModal.vue?vue&type=script&lang=js"
export * from "./PayPalConfirmModal.vue?vue&type=script&lang=js"

import "./PayPalConfirmModal.vue?vue&type=style&index=0&id=23a1a05c&scoped=true&lang=scss"
import "./PayPalConfirmModal.vue?vue&type=style&index=1&id=23a1a05c&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a1a05c"]])

export default __exports__